import qs from "qs"

export default class News {
  constructor() {
    this.categoryFilter = $("#category-filter")
    this.typeFilter = $("#type-filter")

    this.filters = {
      category: null,
      blog_program: qs.parse(location.search.replace("?", "")).blog_program,
      blog_race: qs.parse(location.search.replace("?", "")).blog_race,
      post_type: qs.parse(location.search.replace("?", "")).post_type,
    }

    this.categoryFilter.on("change", (event) => {
      this.filters.category = event.target.value === "" ? null : event.target.value
      this.changeFilter()
    })

    this.typeFilter.on("change", (event) => {
      this.filters.post_type = event.target.value === "" ? null : event.target.value
      this.changeFilter()
    })
  }

  changeFilter() {
    const queryString = qs.stringify(this.filters, { skipNulls: true })
    const newUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      (queryString ? `?${queryString}` : "")
    window.location.href = newUrl
  }
}
